import { ICellRenderer } from 'ag-grid-community';

export default class StatusRenderer implements ICellRenderer {
  private eGui: HTMLElement;
  private statusMappingClasses: { [key: string]: string } = {
    error: 'error',
    warning: 'warning',
    success: 'success',
    info: 'info',
  };

  public init(params: any): void {
    this.eGui = document.createElement('div');

    if (params?.statusMappingConfig) {
      this.statusMappingClasses = params?.statusMappingConfig;
    }
    const statusChip = document.createElement('status-chip');
    const currentValue = params?.getStatusValue ? params?.getStatusValue(params?.node?.data) : params.value;
    
    statusChip.statusValue = currentValue;
    statusChip.statusClasses = this.statusMappingClasses;
    statusChip.dense = true;
    statusChip.innerHTML = currentValue;
    this.eGui.appendChild(statusChip);
  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(): boolean {
    return true;
  }
}
